import React, { useState, useEffect } from "react";
import NewHeader from "../components/NewHeader/NewHeader";
import Footer from "../components/Footer/Footer";
import UpcomingEvents from "./UpcomingEvents";
import ContactUsNew from "./homePage/Components/ContactUsNew";
import Modal from "react-responsive-modal";
import FranchiseForm from "./homePage/Components/FranchiseForm";
import {
  getEvents,
  postFrenchiseInfo,
  getCity,
  setCity,
} from "../Redux/Actions";
import LpForm from "./LandingPages/Component/LpForm";
import { useDispatch, useSelector } from "react-redux";
import SimpleForm from "../components/chatbot/SimpleForm";

import "./Franchise.css";
function Franchise(props) {
  console.log("props", props);
  //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE
  const navCity = useSelector((state) => state.navCityList);
  const { navCities } = navCity;
  const citiesFromArray = navCities;

  const userProfile = useSelector((state) => state.customerDashboard);
  const { loading: userLoading, packages } = userProfile;
  const isLogout = useSelector((state) => state.setLogoutReducer);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const [userName, setUsername] = useState("");
  const [nameError, setNameError] = useState("");
  const [disable, setDisable] = useState(true);
  const [userPhone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const [displayCityList, setDisplay] = useState(true);
  const [success, setSuccess] = useState("");
  const [userCity, setUserCity] = useState("");
  const handelUserName = (e) => {
    // setshowPopUp()
    setUsername(e.target.value);
    const characterRegex =/^([A-Za-z]+[ ]?)+$/;
    setNameError("");
    if (!e.target.value.match(characterRegex)) {
      setNameError("invalid user name");
    }
    if (e.target.value == "") {
      setNameError("");
    }
  };

  ///////
  useEffect(() => {
    if (isLogout && isLogout?.isLogout && isLogout?.isLogout !== "") {
      setUsername("");
      setPhone("");
    } else {
      if (userLoading) {
      } else if (userLoading == false) {
        if (packages && packages?.profile && packages?.profile) {
          setUsername(packages?.profile?.fullname);
          setPhone(packages?.profile?.phonenumber);
        } else {
          setUsername("");
          setPhone("");
        }
      }
    }
  }, [userProfile, isLogout]);

  useEffect(() => {
    if (
      userName == "" ||
      userCity == "" ||
      userPhone == "" ||
      nameError != "" ||
      phoneError != ""
    ) {
      setDisable(true);
    } else {
      setDisable(false);
    }
    console.log("log", disable);
  }, [userName, userCity, userPhone, nameError, phoneError]);

  const setInputcity = (val) => {
    setUserCity(val);
    setDisplay(false);
  };

  useEffect(() => {
    dispatch(getCity());
  }, []);
  //handelPhonechange
  const handelPhoneChange = (e) => {
    setPhone(e.target.value);
    setPhoneError("");
  };

  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!userPhone.match(phoneno) || parseInt(userPhone[0]) < 6) {
      setPhoneError("Enter a valid number");
    } else {
      setPhoneError("");
    }
  };

  //
  const handelCityChange = (e) => {
    setUserCity(e.target.value);
    setDisplay(true);
  };
  ///handel frenchise submit
  const handelFranchiseForm = (e) => {
    e.preventDefault();
    const frenchiseBody = {
      name: userName,
      mobile: userPhone,
      city_name: userCity,
      message: "For Partnership Enquiry",
      url: "https://redcliffelabs.com/franchising-opportunities",
    };
    dispatch(postFrenchiseInfo(frenchiseBody));
    setUsername("");
    setPhone("");
    setUserCity("");
    setSuccess("Your form has been submitted successfully");
    setTimeout(() => {
      setSuccess("");
    }, 3000);
  };
  return (
    <div className="franchise_opprtunity">
      <NewHeader />
      <div className="franchiseBanner">
        <div className="frnchiseContainer">
          <div className="frnLeft">
            <div className="textContent">
              <div className="frenchiseForm">
                <h1 className="blue-Bold">
                  <div>Start Your </div>
                  <div>
                    <span className="boldpink">ENTREPRENEURIAL JOURNEY</span>{" "}
                    With Us
                  </div>
                </h1>
                <p className="font2-5">For Partnership Enquiry</p>
              </div>
              <form className="franchiseForm" onSubmit={handelFranchiseForm}>
                <div className="inputField">
                  <div className="inputCustom">
                    <img
                      src="https://staticcdn.redcliffelabs.com/media/gallary-images/None/dff3a934-4276-4959-98e6-1c42027c37b1.png"
                      alt="number"
                    />
                    <input
                      required
                      onChange={handelPhoneChange}
                      onBlur={() => validatePhoneNumber()}
                      type="text"
                      value={userPhone}
                      placeholder="Enter Your Mobile Number*"
                    />
                  </div>
                  <span className="error">{phoneError}</span>
                </div>
                <div className="inputField">
                  <div className="inputCustom">
                    <img
                      src="https://staticcdn.redcliffelabs.com/media/gallary-images/None/fb5bc5c9-a577-40c8-99f1-f7d373bd1f77.png"
                      alt="number"
                    />
                    <input
                      onChange={handelUserName}
                      value={userName}
                      required
                      type="text"
                      placeholder="Enter Your Name"
                    />
                  </div>
                  <span className="error">{nameError}</span>
                </div>
                <div className="inputField">
                  <div className="inputCustom">
                    <img
                      src="https://staticcdn.redcliffelabs.com/media/gallary-images/None/31d3cc75-7b26-4a10-86f7-b2aac7c0ab76.png"
                      alt="number"
                    />
                    <input
                      onChange={handelCityChange}
                      value={userCity}
                      required
                      type="text"
                      placeholder="Enter City"
                    />
                    {/* <img
                      className="caret"
                      src="https://staticcdn.redcliffelabs.com/media/gallary-images/None/1c11fe35-8e92-4484-bfd2-276ffb413bcc.png"
                      alt="caret"
                    /> */}
                  </div>
                  {displayCityList != "" ? (
                    <div
                      className={
                        userCity && userCity !== "" ? "cityList" : "displayNone"
                      }
                      id="cityList"
                    >
                      {userCity !== "" &&
                      citiesFromArray &&
                      citiesFromArray.cities
                        ? citiesFromArray.cities
                            .filter((name) => {
                              if (userCity == "") {
                                return name;
                              } else if (
                                name
                                  .toLowerCase()
                                  .includes(userCity.toLowerCase())
                              ) {
                                return name;
                              }
                            })
                            .map((values, index) => {
                              if (index < 2) {
                                return (
                                  <>
                                    <div
                                      onClick={() => setInputcity(values)}
                                      key={index}
                                      className={
                                        displayCityList
                                          ? "cityLIstLP"
                                          : "displayNone"
                                      }
                                    >
                                      <span>{values}</span>
                                    </div>

                                    {/* <div
                                className="cityItem"
                                key={index}
                                onClick={() => setCity(filteredName)}
                              >
                                {" "}
                                <span>{filteredName}</span>{" "}
                              </div> */}
                                  </>
                                );
                              }
                            })
                        : null}
                    </div>
                  ) : null}

                  <span className="error"></span>
                </div>

                <button
                  disabled={disable ? "disabled" : ""}
                  className={
                    disable ? "disabled frenchiseSubmit" : "frenchiseSubmit"
                  }
                  type="submit"
                >
                  Get A Call Now
                </button>
                <p className="success">{success}</p>
              </form>
            </div>
            {/* <div className="fixed_querry">
              <div className="maxwidth">
                <div className="hyperLink">
                  <img
                    src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/20ae15ac-f827-4483-87cd-3ce8d5427fbc.png"
                    alt="phone_icon"
                  />{" "}
                  <a href="tel:92890 14414">92890 14414</a>
                </div>
                <div className="vertical" />
                <div className="hyperLink mobileLink">
                  <img
                    className="desktopBrowser"
                    src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/8718d5ab-1b44-40d9-8d4d-f557e1a979bb.png"
                    alt="brwoser"
                  />
                  <img
                    src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/421ebd20-6d09-4049-886e-45cfc0328150.png"
                    alt="brwoser"
                    className="mobileBrowser"
                  />
                  <a href="mailto:ccpartner@redcliffelabs.com">
                    ccpartner@redcliffelabs.com
                  </a>
                </div>
              </div>
            </div> */}
          </div>
          <div className="frnRight">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/b7c19989-c8f1-43b3-8925-398e540e8f5b.png"
              alt="banner"
            />
          </div>
        </div>
      </div>
      <section className="diagnosticGame">
        <div className="chil">
          <div className="top_Header">
            <h2>Changing The Diagnostics Game</h2>
            <p>
              We aim to meet our customers & health needs by providing complete
              healthcare services.
            </p>
          </div>
          <div className="main_franchise">
            <div className="box_fran">
              <p className="bold">20+</p>
              <p>Labs</p>
            </div>
            <div className="box_fran " style={{ background: "#E8ECF8" }}>
              <p className="bold">700+</p>
              <p>
                Collection <br />
                Center
              </p>
            </div>
            <div className="box_fran" style={{ background: "#DBF5F9" }}>
              <p className="bold">2 Lakh</p>
              <p>Test daily</p>
            </div>
            <div className="box_fran">
              <p className="bold">3500+</p>
              <p>Test menu</p>
            </div>
            <div className="box_fran" style={{ background: "#D8EEF9" }}>
              <p className="bold">100+ Cities</p>
              <p>
                Home Sample <br /> Collection Available
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="bluedivContainer">
        <div className="child-Container">
          <div className="frnLeft diagnosticCON">
            <h3>Partner Opportunities</h3>
            <p>
              Align your passion & talent with the India's most trusted and
              fastest growing network of pathology labs
            </p>
            <button onClick={onOpenModal}>ENQUIRE NOW</button>
            <div className="franchise_modal">
              <Modal
                classNames={{
                  overlay: "customOverlay",
                  modal: "franchise_modal",
                }}
                open={open}
                onClose={onCloseModal}
                center
              >
                <FranchiseForm />
              </Modal>
            </div>
          </div>
          <div className="frnRight">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/c4255ff8-4a02-4e27-a492-02d0cce8b0cc.png"
              alt="plane"
            />
          </div>
        </div>
      </section>

      <section className="cardsForFrenchise">
        <div className="whypartnerWithus">
          <h2>Why Partner With Redcliffe Labs</h2>
        </div>
        <div className="partner_testimonial">
          <div className="partner_card">
            <div className="contentFrenchise">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/c0a42956-dd20-445f-bb16-a9b20ff9aba0.png"
                alt="test"
              />
              <h3>Business Setup</h3>
              <p>
                Accelerate your business with improved sales, profits and
                enhanced customer base.
              </p>
            </div>
          </div>

          <div className="partner_card">
            <div className="contentFrenchise">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/f0a18994-c16e-46f6-bf38-024427a23664.png"
                alt="test"
              />
              <h3>Channel Team And Sales</h3>
              <p>
                Increase your business growth by way of qualified leads & smooth
                operations.
              </p>
            </div>
          </div>

          <div className="partner_card">
            <div className="contentFrenchise">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/ea355422-dc91-4aa4-94ca-0e900504e2f4.png"
                alt="test"
              />
              <h3>Branding And Marketing</h3>
              <p>
                Region-specific marketing campaigns to build brand awareness
              </p>
            </div>
          </div>

          <div className="partner_card">
            <div className="contentFrenchise">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/e7eaf9c1-c282-4991-9cbe-9bab172009d9.png"
                alt="test"
              />
              <h3>Awareness Program Set Up</h3>
              <p>
                Build brand equity and increase customer loyalty through
                personalized awareness programs.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <UpcomingEvents /> */}

      <ContactUsNew
        telNumber="92890 14414"
        email="ccpartner@redcliffelabs.com"
        frenchise={true}
      />
      <div className="chatbot">
        <SimpleForm />
      </div>
      <Footer />
    </div>
  );
}

export default { component: Franchise };
